/**
 * External Dependencies
 */
import accordion from './components/accordion';
import cardhover from './components/cardhover';
import dropdownhover from './components/dropdownhover';
import headernavigation from './components/headernavigation';
import redirecturl from './components/redirecturl';
import videohome from './components/videohome';
import Controller from './helpers/Controller';


const modules = [
    headernavigation,
    dropdownhover,
    videohome,
    cardhover,
    accordion,
    redirecturl
];
const controller = new Controller(modules);
controller.ready();

// @note - this will popup a confirmation before leaving the page
// window.onbeforeunload = () => controller.destroy();
